import React, { ReactNode } from "react";
import { BannerContext } from "../context/BannerContext";
import { IdMeButtonProps } from "../types";

interface ContextProviderProps {
  children: ReactNode;
  isSignedIn?: boolean;
  customerId?: string;
  idMeButton?: IdMeButtonProps;
}

export const ContextProvider = ({
  children,
  isSignedIn,
  customerId,
  idMeButton,
}: ContextProviderProps) => {
  return (
    <BannerContext.Provider value={{ isSignedIn, customerId, idMeButton }}>
      {children}
    </BannerContext.Provider>
  );
};
